import { X } from "lucide-react"
import React, { useState } from "react"

const FloatingWidgets: React.FC = () => {
  const [showDelivery, setShowDelivery] = useState(true)

  return (
    <>
      {/* Shopee, BE, Grab, Xanh — bên phải */}
      {showDelivery && (
        <div className="fixed right-[4px] bottom-24 z-50 flex flex-col gap-[4px]">
          <button
            onClick={() => setShowDelivery(false)}
            className="mb-1 flex h-[28px] w-[28px] items-center justify-center self-end rounded-full bg-white/80 shadow-md transition-colors hover:bg-white"
            title="Ẩn"
          >
            <X size={16} className="text-gray-500" />
          </button>
          <a
            href="https://shopeefood.vn/u/b5yPDxW"
            target="_blank"
            rel="noreferrer"
            className="flex h-[54px] w-[54px] items-center justify-center drop-shadow-md transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-SPF.png"
              alt="Shopee Food"
              className="animate-shake h-full w-full origin-center scale-[1.15] object-contain"
            />
          </a>
          <a
            href="https://begroup.onelink.me/ZOqn/TraSuaVaMiloDamTutimi"
            target="_blank"
            rel="noreferrer"
            className="flex h-[54px] w-[54px] items-center justify-center drop-shadow-md transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-BEFOOD.png"
              alt="Be Food"
              className="animate-shake h-full w-full origin-center scale-[1.2] object-contain"
            />
          </a>
          <a
            href="https://grb.to/TrasuaTutimi"
            target="_blank"
            rel="noreferrer"
            className="flex h-[54px] w-[54px] items-center justify-center drop-shadow-md transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-GRAB.png"
              alt="Grab"
              className="animate-shake h-full w-full origin-center scale-[1.2] object-contain"
            />
          </a>
          <a
            href="https://xanhsmngon.onelink.me/14WJ/eskypizy"
            target="_blank"
            rel="noreferrer"
            className="flex h-[54px] w-[54px] items-center justify-center drop-shadow-md transition-all duration-300 hover:-translate-y-1 hover:drop-shadow-lg"
          >
            <img
              src="/icons/W-XANH.png"
              alt="Xanh SM"
              className="animate-shake h-full w-full origin-center scale-[1.2] object-contain"
            />
          </a>
        </div>
      )}
    </>
  )
}

export default FloatingWidgets
